import type { ReactElement } from 'react';
import React from 'react';
import clsx from 'clsx';
import type { Skeleton } from 'atom-components/skeleton/types';
import './tabs.scss';

type Props = Skeleton & { tabs?: number };

/**
 *
 * @param param0
 * @returns
 */
export default function Tabs({ tabs = 3, loading, error }: Props): ReactElement {
  return (
    <ul className={clsx('nav nav-tabs skeleton-tabs', { error })}>
      {[...Array(tabs)].map((tab, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <li key={`placeholder-tab-${i}`} className="nav-item">
          <span
            className={clsx('btn nav-link', {
              active: i === 0
            })}
          >
            <span className={clsx('btn nav-link skeleton-box', { loading, error })} />
          </span>
        </li>
      ))}
    </ul>
  );
}
